import React from 'react';
import PropTypes from 'prop-types';

import Translate from '@hydra/common/components/i18n';
import Criterium from '@hydra/common/criterium/Criterium';

const isClean = data => data.clean;
const isCleanEnough = data => (data.total / 10) > data.count;
const hasExtensions = data => data.extensions && data.extensions.length > 0;

const getDataExplanation = data => {
  if (data && (isClean(data) || isCleanEnough(data))) {
    return (hasExtensions(data))
      ? 'clean_url_perfect'
      : 'clean_url_ok';
  }

  return 'clean_url_ko';
};

export const CleanUrl = ({ criterium }) => {
  const { data } = criterium;
  const content = <Translate content={getDataExplanation(data)} />;

  return <Criterium criterium={criterium}>{content}</Criterium>;
};

CleanUrl.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      clean: PropTypes.bool,
      total: PropTypes.number,
      count: PropTypes.number,
      extensions: PropTypes.array
    })
  })
};

export default React.memo(CleanUrl);
